import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { Control, Controller, FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { DetailedInfo } from "./types";

interface RecursiveDetailSurveyViewProps {
  register: UseFormRegister<any>;
  control: Control<any>;
  errors: FieldErrors;
  watch: UseFormWatch<any>;
  IsSubSection: boolean;
  showSubmitButton: boolean;
  setValue: UseFormSetValue<any>;
  currentRecord: number;
  questionCounter: number;
  isDraft: boolean;
  submitButtonClicked: boolean;
  RecursiveInnerSurveySections: DetailedInfo[] | null;
}  

const PollView: React.FC<RecursiveDetailSurveyViewProps> = ({
  register,
  control,
  errors,
  watch,
  IsSubSection,
  showSubmitButton,
  setValue,
  currentRecord,
  questionCounter,
  isDraft,
  submitButtonClicked,
  RecursiveInnerSurveySections,
}) => {
    const [applyValidation, setApplyValidation] = useState(true);
    const formRef = useRef<HTMLDivElement>(null);
  
    useEffect(() => {
      const firstErrorField = Object.keys(errors)?.[0];
      if (firstErrorField) {
        setTimeout(() => {
          const element = formRef.current?.querySelector(
            `[data-name="${firstErrorField}"]`
          ) as HTMLElement;
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
            element.focus();
          }
        }, 500);
      }
    }, [errors, submitButtonClicked]);
  
    const getErrorMessage = (questionId: number) => {
      const error = errors[`question_${questionId}`];
      if (error) {
        return (error.message as string) || "";
      }
      return "";
    };
  
    useEffect(() => {
      setApplyValidation(showSubmitButton);
    }, [showSubmitButton]);
  
    return (
      <>
        <div ref={formRef}>
          {RecursiveInnerSurveySections &&
          RecursiveInnerSurveySections?.length > 0 ? (
            RecursiveInnerSurveySections?.map((question) => (
              <div>
                {(!question?.BranchQuestionId ||
                  (question?.BranchQuestionId &&
                    watch(`question_${question?.BranchQuestionId}`) &&
                    watch(`question_${question?.BranchQuestionId}`) ==
                      question?.QuestionResponseOptionId)) && (
                  <div
                    className="questions "
                    key={question?.QuestionId}
                    data-name={`question_${question?.QuestionId}`}
                  >
                    <h5>
                      {questionCounter++}.{question?.QuestionTitle}
                      {question?.IsRequired === true && (
                        <span className="text-danger ml-1">*</span>
                      )}
                      {question?.Instruction && (
                        <span className="ques-instruction">
                          ({question?.Instruction})
                        </span>
                      )}
                    </h5>
                    {question?.SurveyQuestionResponseDetails?.map(
                      (responseDetail) => (
                        <div key={responseDetail?.QuestionResponseId}>
                          {responseDetail?.ResponseTypeName ===
                            "Radio Button" && (
                            <Controller
                              name={`question_${question?.QuestionId}`}
                              control={control}
                              rules={{
                                required:
                                  applyValidation && question?.IsRequired === true
                                    ? "This field is required"
                                    : false,
                              }}
                              render={({ field: { onChange, value } }) => (
                                <>
                                  <div>
                                    {responseDetail?.QuestionResponseOptions?.map(
                                      (option) => (
                                        <Form.Check
                                          key={option?.QuestionResponseOptionId}
                                          type="radio"
                                          label={
                                            option?.QuestionResponseOptionValue
                                          }
                                          value={option?.QuestionResponseOptionId}
                                          checked={
                                            value ==
                                            option?.QuestionResponseOptionId
                                          }
                                          onChange={(e) => {
                                            onChange(e);
                                          }}
                                          disabled={!applyValidation && !isDraft}
                                        />
                                      )
                                    )}
                                  </div>
                                  {errors[`question_${question?.QuestionId}`] && (
                                    <span className="text-danger">
                                      {getErrorMessage(question?.QuestionId)}
                                    </span>
                                  )}
                                </>
                              )}
                            />
                          )}
  
                          {responseDetail?.ResponseTypeName === "CheckBox" && (
                            <Controller
                              name={`question_${question?.QuestionId}`}
                              control={control}
                              rules={{
                                required:
                                  applyValidation && question?.IsRequired === true
                                    ? "This field is required"
                                    : false,
                              }}
                              defaultValue={[]}
                              render={({ field: { onChange, value = [] } }) => {
                                const checkedValues =
                                  typeof value === "string"
                                    ? value.split(",")
                                    : Array.isArray(value)
                                    ? value
                                    : [];
  
                                return (
                                  <>
                                    <div>
                                      {responseDetail?.QuestionResponseOptions?.map(
                                        (option) => {
                                          const optionId =
                                            option?.QuestionResponseOptionId.toString();
                                          const isChecked =
                                            checkedValues?.includes(optionId);
  
                                          return (
                                            <Form.Check
                                              key={optionId}
                                              type="checkbox"
                                              label={
                                                option?.QuestionResponseOptionValue
                                              }
                                              value={optionId}
                                              checked={isChecked}
                                              onChange={() => {
                                                let newValue = Array.isArray(
                                                  checkedValues
                                                )
                                                  ? [...checkedValues]
                                                  : [];
  
                                                if (
                                                  newValue?.includes(optionId)
                                                ) {
                                                  newValue = newValue?.filter(
                                                    (v) => v !== optionId
                                                  );
                                                } else {
                                                  newValue?.push(optionId);
                                                }
  
                                                onChange(newValue);
                                              }}
                                              disabled={
                                                !applyValidation && !isDraft
                                              }
                                            />
                                          );
                                        }
                                      )}
                                    </div>
                                    {errors[
                                      `question_${question?.QuestionId}`
                                    ] && (
                                      <span className="text-danger">
                                        {getErrorMessage(question?.QuestionId)}
                                      </span>
                                    )}
                                  </>
                                );
                              }}
                            />
                          )}                        
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="px-4">
              <div className="alert alert-danger mt-3 py-2">
                No questions available
              </div>
            </div>
          )}
        </div>
      </>
    );
  };

export default PollView;
